import React from 'react';
import { FsComponentSize } from 'globals/types';
import defaultLocales from 'globals/locales/default';
import { TabsProps } from '@material-ui/core';
import FsTab from './FsTab/FsTab';
import { FsTabs, FsTabsContainer } from './FsTabPanel.style-elements';

interface FsTabPanelProps extends Pick<TabsProps, 'variant'> {
  labels: string[];
  size?: FsComponentSize.M | FsComponentSize.L;
  onChange: (
    event: React.ChangeEvent<Record<string, unknown>>,
    newValue: number
  ) => void;
  value: number;
}

const FsTabPanel: React.FC<FsTabPanelProps> = ({
  labels,
  size,
  onChange,
  value,
  variant = 'scrollable',
}) => {
  return (
    <FsTabsContainer>
      <FsTabs
        value={value}
        onChange={onChange}
        aria-label={defaultLocales.tabs}
        variant={variant}
      >
        {labels.map((label: string) => (
          <FsTab
            key={label}
            {...{ label, size: size || FsComponentSize.M }}
            data-test="tab-panel"
          />
        ))}
      </FsTabs>
    </FsTabsContainer>
  );
};

export default FsTabPanel;
